import { AlgoliaConfig } from "@/utils/types/algolia";

export const ALGOLIA_CACHING_STATUS = false;

export const ALGOLIA_INDEXES = {
  QUERY_SUGGESTIONS: {
    PRIMARY_INDEX: "dxp_product_en_query_suggestions",
  },
  PRODUCTS: {
    PRIMARY_INDEX: "dxp_product_en",
    REPLICA_INDEXES: {
      NAME_ASC: "dxp_product_en_name_asc",
      NAME_DESC: "dxp_product_en_name_desc",
      PRICE_ASC: "dxp_product_en_price_asc",
      PRICE_DESC: "dxp_product_en_price_desc",
    },
  },
  RECIPES: {
    PRIMARY_INDEX: "dxp_recipes_en",
    REPLICA_INDEXES: {
      TITLE_ASC: "dxp_recipes_en_title_asc",
      TITLE_DEC: "dxp_recipes_en_title_desc",
      OLDEST_DATE: "dxp_recipes_en_publish_asc",
      NEWEST_DATE: "dxp_recipes_en_publish_desc",
    },
  },
  ARTICLES: {
    PRIMARY_INDEX: "dxp_articles_en",
    REPLICA_INDEXES: {
      TITLE_ASC: "dxp_articles_en_title_asc",
      TITLE_DEC: "dxp_articles_en_title_desc",
      NEWEST_DATE: "dxp_articles_en_publish_desc",
      OLDEST_DATE: "dxp_articles_en_publish_asc",
    },
  },
  STORES: {
    PRIMARY_INDEX: "dxp_stores",
  },
} as const;

export const algoliaConfig: AlgoliaConfig = {
  appId: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID ?? "",
  apiKey: process.env.NEXT_PUBLIC_ALGOLIA_API_KEY ?? "",
  caching: ALGOLIA_CACHING_STATUS,
  indexNames: {
    recipes: ALGOLIA_INDEXES.RECIPES.PRIMARY_INDEX ?? "",
    products: ALGOLIA_INDEXES.PRODUCTS.PRIMARY_INDEX ?? "",
    productQuerySuggestion:
      ALGOLIA_INDEXES.QUERY_SUGGESTIONS.PRIMARY_INDEX ?? "",
    articles: ALGOLIA_INDEXES.ARTICLES.PRIMARY_INDEX ?? "",
    stores: ALGOLIA_INDEXES.STORES.PRIMARY_INDEX ?? "",
    recipeSort: {
      titleAsc: ALGOLIA_INDEXES.RECIPES.REPLICA_INDEXES.TITLE_ASC ?? "",
      titleDesc: ALGOLIA_INDEXES.RECIPES.REPLICA_INDEXES.TITLE_DEC ?? "",
      newestDate: ALGOLIA_INDEXES.RECIPES.REPLICA_INDEXES.NEWEST_DATE ?? "",
      oldestDate: ALGOLIA_INDEXES.RECIPES.REPLICA_INDEXES.OLDEST_DATE ?? "",
    },
    articleSort: {
      titleAsc: ALGOLIA_INDEXES.ARTICLES.REPLICA_INDEXES.TITLE_ASC ?? "",
      titleDesc: ALGOLIA_INDEXES.ARTICLES.REPLICA_INDEXES.TITLE_DEC ?? "",
      newestDate: ALGOLIA_INDEXES.ARTICLES.REPLICA_INDEXES.NEWEST_DATE ?? "",
      oldestDate: ALGOLIA_INDEXES.ARTICLES.REPLICA_INDEXES.OLDEST_DATE ?? "",
    },
    productSort: {
      titleAsc: ALGOLIA_INDEXES.PRODUCTS.REPLICA_INDEXES.NAME_ASC ?? "",
      titleDesc: ALGOLIA_INDEXES.PRODUCTS.REPLICA_INDEXES.NAME_DESC ?? "",
      newestDate: ALGOLIA_INDEXES.PRODUCTS.REPLICA_INDEXES.PRICE_ASC ?? "",
      oldestDate: ALGOLIA_INDEXES.PRODUCTS.REPLICA_INDEXES.PRICE_DESC ?? "",
    },
  },
  analyticsApiKey: process.env.NEXT_PUBLIC_ALGOLIA_ANALYTICS_API_KEY ?? "",
};

export const RECOMMENDATIONS_API = `https://${process.env.NEXT_PUBLIC_ALGOLIA_APP_ID}.algolia.net/1/indexes/*/recommendations`;

export const POPULAR_SEARCHES_API =
  "https://analytics.us.algolia.com/2/searches";
